import hyperdom from 'hyperdom'
import PaymentGateway from './paymentGateway.jsx'
import formatPrice from '../../../../packages/ui-helpers/formatPrice.js'

export default class PaymentGatewayDeposit extends PaymentGateway {
  constructor (payment, fastTrack) {
    super(payment, fastTrack)
    this.deposit = this.payment.booking.booking.paymentOptions.deposit
    if (this.deposit) {
      this.deposit.tempDesiredPaymentAmount = this.deposit.amount
      this.deposit.desiredPaymentAmount = this.deposit.amount
    }
  }

  paymentOptionTestData () {
    return 'payment-type-deposit'
  }

  eligible () {
    return !!this.deposit
  }

  amount () {
    return this.deposit.desiredPaymentAmount
  }

  paymentOptionName () {
    return 'Pay only a deposit'
  }

  changeDepositAmount () {
    this.payment.modals.show({
      classNames: 'payment-options__change_deposit_modal',
      render: () => this.renderUpdateDepositModal(),
    })
  }

  setDepositAmount () {
    if (this.depositAmountValid()) {
      this.deposit.desiredPaymentAmount = Number(this.deposit.tempDesiredPaymentAmount)
      this.payment.modals.close()
      this.updateOptionsAndRender()
    }
  }

  depositAmountValid () {
    return (Number(this.deposit.tempDesiredPaymentAmount) >= this.deposit.amount &&
      Number(this.deposit.tempDesiredPaymentAmount) <= this.payment.booking.booking.totalAmount)
  }

  renderUpdateDepositModal () {
    return <div>
      <div className='modal__header'>
        <h3>Change deposit</h3>
        <i className='modal__exit' onclick={(ev) => {
          ev.preventDefault()
          this.payment.modals.close()
        }}></i>
      </div>
      <div className='modal__price'>
        <label for='depositAmount'>Amount</label>
        <span class='payment-options__deposit_input_price'>
          <i>{this.payment.departure.prices.currency}</i>
          <input class='o-form-item__txt-input update_deposit__amount'
            binding={[this.deposit, 'tempDesiredPaymentAmount']}
            id='depositAmount'/>
        </span>
      </div>
      {!this.depositAmountValid()
        ? <div class='clearfix'>
          <div class='o-form-item__warning no-arrow payment-options__change_deposit_modal_deposit_error'>
            Deposit payment amount must be between {formatPrice({
              currency: this.payment.departure.prices.currency,
              amount: this.deposit.amount,
            })} and {formatPrice({
              currency: this.payment.departure.prices.currency,
              amount: this.payment.booking.booking.totalAmount,
            })}
          </div>
        </div>
        : undefined}
      <div className='update_deposit__actions'>
        <a className=' btn-secondary update_deposit__actions_update' href='#' onclick={(ev) => {
          ev.preventDefault()
          this.setDepositAmount()
        }}>Update</a>
      </div>
    </div>
  }

  renderPrice () {
    return <div className='payment-option__price'>
      <div className='payment-option__price-val price-blue'>
        {formatPrice({
          currency: this.payment.departure.prices.currency,
          amount: this.deposit.desiredPaymentAmount,
        })}
      </div>
      {PaymentGateway.loadingFailed ? undefined : <a className={['payment-option__price-change', {'-visible': this.payment.paymentOption() === this}]}
        onclick={() => this.changeDepositAmount()}>Change amount</a>}
    </div>
  }
}
